<template>
  <ODialog
    ref="dialog"
    :title="$t('components.customerNote.delete.title')"
    :info="$t('components.customerNote.delete.info')"
    :options="[
      { text: $t('general.cancel'), type: 'cancel' },
      { text: $t('general.confirm'), type: 'confirm', variant: 'danger', callback: confirm },
    ]"
    :portal="portal"
  />
</template>

<script setup lang="ts">
import type { CustomerNote } from '~/_api/models/customerNote'

interface Props {
  portal?: string
  loading?: boolean
}

interface Emits {
  (e: 'update:loading', value: boolean): void
  (e: 'success'): void
  (e: 'error'): void
}

const props = withDefaults(defineProps<Props>(), {
  portal: undefined,
  loading: false,
})

const emit = defineEmits<Emits>()
const { $api, $i18n, $notification, $bus } = useNuxtApp()

const dialog = ref()
const customerNote = ref<CustomerNote | null>(null)

const open = (customerNoteItem: CustomerNote) => {
  customerNote.value = customerNoteItem
  dialog.value.open()
}

const confirm = async () => {
  if (!customerNote.value) return

  emit('update:loading', true)

  try {
    const success = await $api.customerNote.delete(customerNote.value)
    emit('update:loading', false)

    if (success) {
      $notification.toast({
        title: $i18n.t('components.customerNote.delete.success'),
        text: $i18n.t('components.customerNote.delete.successInfo'),
        variant: 'success',
      })

      emit('success')

      $bus.emit.updated('Customer', { idCustomer: Number(customerNote.value?.idCustomer) })

      return true
    }
  } catch (e) {
    $notification.toast({
      title: $i18n.t('components.customerNote.delete.error'),
      text: $i18n.t('components.customerNote.delete.errorInfo'),
      variant: 'danger',
    })

    console.log(e)

    emit('error')
  }
}

defineExpose({
  open,
})
</script>
